import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Typography,
  Card,
  Spin,
  Button,
  Form,
  Row,
  Col,
  Flex,
  Steps,
} from "antd";

//PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import styles from "../../../assets/styles/styles";
// import TillAuthorizationForm from "./components/TillAuthForm";
// import BranchLimitForm from "./components/BranchLimitsForm";

import Preview from "./components/Preview";
import { labelConfig, staticConfig, apiConfig } from "../systemAdmin.config";
import ConfigForm from "./components/ConfigForm";
import CurrencyForm from "./components/CurrencyForm";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const AddSYA0500 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { Text, Title } = Typography;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [current, setCurrent] = useState(0);
  const [configValues, setConfigValues] = useState([]);
  const [currencyInforValues, setCurrencyInforValues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    configForm: null,
    currencyForm: [],
  });
  const [codeValueData, setCodeValueData] = useState([]);

  const [officeData, setOfficeData] = useState([]);
  const [templateConfigDetail, setTemplateConfigDetail] = useState({});
  const [currencyData, setCurrencyData] = useState([]);
  const [glAccountData, setGLAccountData] = useState([]);
  const [currencyCount, setCurrencyCount] = useState(0);
  const [transactionCurrencyData, setTransactionCurrencyData] = useState([]);
  const [configureCurrencyTableSource, setConfigureCurrencyTableSource] =
    useState([]);

  const [branchOpConfigData, setBranchOpConfigData] = useState(null);
  const [vaultConfigData, setVaultConfigData] = useState(null);
  const [branchConfigList, setBranchConfigList] = useState([]);
  const [selectedbranchConfigValue, setSelectedbranchConfigValue] = useState(0);
  const [
    selectedbranchConfigValueCurrencyCode,
    setSelectedbranchConfigValueCurrencyCode,
  ] = useState(0);

  useEffect(() => {
    getCurrencies();
    getGLAccounts();
    getBranchOpConfig();
    getVaultConfig();
  }, []);

  // Once both raw datasets are loaded, compute unconfigured branches
  useEffect(() => {
    if (!branchOpConfigData || !vaultConfigData) return;

    const configuredOperationIds = new Set(
      vaultConfigData.map((v) => v.operationId2?.id),
    );

    const unconfigured = branchOpConfigData.filter(
      (b) => !configuredOperationIds.has(b.id),
    );
    setBranchConfigList(
      unconfigured.map((element) => ({
        value: element.id,
        label: element.officeId?.name,
      })),
    );
  }, [branchOpConfigData, vaultConfigData]);

  const onFinishConfigForm = (values) => {
    console.log(values);

    setFormData({ ...formData, configForm: values });
    setCurrent(current + 1);
  };

  const onFinishCurrencyForm = (values) => {
    const tempConfigData = configureCurrencyTableSource.map((element) => ({
      currencyCode: element.currencyCode,
      vaultMaxAmount: element.vaultMaxAmount,
      locale: "en",
    }));

    setFormData({ ...formData, currencyForm: tempConfigData });

    // Move to next step
    setCurrent(current + 1);
  };

  useEffect(() => {
    if (selectedbranchConfigValue > 0) {
      getBranchCurrencyrestrById();
    }
  }, [selectedbranchConfigValue]);
  const forms = [
    <ConfigForm
      onFinish={onFinishConfigForm}
      initialValues={formData.configForm}
      form={useForm}
      officeData={officeData}
      branchConfigList={branchConfigList}
      glAccountData={glAccountData}
      setSelectedbranchConfigValue={setSelectedbranchConfigValue}
    />,
    <CurrencyForm
      onFinish={onFinishCurrencyForm}
      initialValues={formData.currencyForm}
      currencyCount={currencyCount}
      setFormData={setFormData}
      form={useForm}
      currencyData={currencyData}
      glAccountData={glAccountData}
      setCurrencyCount={setCurrencyCount}
      configureCurrencyTableSource={configureCurrencyTableSource}
      setConfigureCurrencyTableSource={setConfigureCurrencyTableSource}
      selectedbranchConfigValueCurrencyCode={
        selectedbranchConfigValueCurrencyCode
      }
    />,

    <Preview
      formData={formData}
      currencyData={currencyData}
      officeData={officeData}
      branchConfigList={branchConfigList}
      glAccountData={glAccountData}
      setCurrencyCount={setCurrencyCount}
      configureCurrencyTableSource={configureCurrencyTableSource}
      setConfigureCurrencyTableSource={setConfigureCurrencyTableSource}
    />,
  ];

  const isLastStep = current === forms.length - 1;

  const nextButtonClick = () => {
    useForm.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  const getOffices = () => {
    setIsLoading(true);

    const url = apiConfig.Offices;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setTemplateConfigDetail(res);
        const objDetails = res;
        let tempOfficeData = [];

        objDetails?.forEach((element) => {
          tempOfficeData.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(tempOfficeData);

        setIsLoading(false);
      }
    });
  };

  const getCurrencies = () => {
    setIsLoading(true);

    const url = apiConfig.Currencies;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetails = res;
        let tempCurrencyData = [];

        objDetails?.selectedCurrencyOptions?.forEach((element) => {
          tempCurrencyData.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        setCurrencyData(tempCurrencyData);

        setIsLoading(false);
      }
    });
  };

  const getGLAccounts = () => {
    setIsLoading(true);

    const body = {
      session,
      params: { offset: 0, orderBy: "id", sortOrder: "DESC" },
    };

    BOM.FetchReqAction(body, apiConfig.GLAccounts, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const items = res?.pageItems ?? [];
        setGLAccountData(
          items.map((element) => ({
            value: element.id,
            label: element.name,
          })),
        );
        setIsLoading(false);
      }
    });
  };

  const getBranchOpConfig = () => {
    setIsLoading(true);
    BOM.FetchReqAction({ session }, apiConfig.Branchoprconfig, (err, res) => {
      if (err) {
        BOM.AlertMsg(
          cnt.DANGER,
          err?.errors[0]?.defaultUserMessage || err.defaultUserMessage,
        );
        setIsLoading(false);
        return;
      }
      setBranchOpConfigData(res || []);
      setIsLoading(false);
    });
  };

  const getVaultConfig = () => {
    setIsLoading(true);
    BOM.FetchReqAction({ session }, apiConfig.VaultConfig, (err, res) => {
      if (err) {
        BOM.AlertMsg(
          cnt.DANGER,
          err?.errors[0]?.defaultUserMessage || err.defaultUserMessage,
        );
        setIsLoading(false);
        return;
      }
      setVaultConfigData(res || []);
      setIsLoading(false);
    });
  };

  const getBranchCurrencyrestrById = () => {
    let body = { session };
    // selectedbranchConfigValue
    let url = `${
      apiConfig.Branchoprconfig +
      `/branchcurrencyrestr` +
      `/${selectedbranchConfigValue}`
    }`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        console.log(res);

        const currencyOptions = res.map((item) => ({
          value: item.currencyCode,
          label: item.currencyCode,
        }));

        setSelectedbranchConfigValueCurrencyCode(currencyOptions);
      }
    });
  };

  // const getCodeValues = (param) => {
  //   setIsLoading(true);

  //   const url = `${apiConfig.Codes}/${param.id}/ CodeValues`;

  //   let body = {
  //     session,
  //   };

  //   /** FETCH ROLE */
  //   BOM.FetchReqAction(body, url, (err, res) => {
  //     if (err) {
  //       BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
  //     } else {
  //       const objDetails = res;
  //       let tempCodeValueData = [];

  //       objDetails?.forEach((element) => {
  //         tempCodeValueData.push({
  //           value: element.id,
  //           label: element.name,
  //         });
  //       });

  //       setCodeValueData(tempCodeValueData);

  //       setIsLoading(false);
  //     }
  //   });
  // };

  const onSubmit = () => {
    const payload = {
      locale: "en",
      operationId: formData?.configForm?.operationId,
      vaultGl: formData?.configForm?.vaultGl,
      tillGl: formData?.configForm?.tillGl,
      vaultCcyRestrConfs: formData?.currencyForm?.map((item) => ({
        vaultCcyRestrConf: {
          locale: item.locale || formData?.configForm?.locale,
          currencyCode: item.currencyCode,
          vaultMaxAmount: item.vaultMaxAmount.toString(),
        },
      })),
    };

    const body = {
      ...payload,
      locale: "en",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      apiConfig.VaultConfig,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Branch valult created successfully");
          navigate("/sya0500");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/sya0500");
          setIsLoading(false);
        },
      },
    );
  };

  function onCancel() {
    navigate("/sya0500", { replace: false });
  }

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.newVaultConfiguration}
        pageItems={staticConfig.newVaultConfigurationBreadcrumbItems}
      />
      <Spin spinning={isLoading} tip="Loading..." size="large">
        <Card title={"Vault Config..."} style={styles.cardWrapper}>
          <div>
            <Row
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
              style={{ marginBottom: 25 }}
            >
              <Col span={24}>
                <Row style={{ justifyContent: "space-between" }}>
                  <Card style={styles.cardSteps}>
                    <Steps
                      current={current}
                      onChange={setCurrent}
                      direction="vertical"
                      style={{ height: "600px" }}
                      items={[
                        {
                          title: <Text strong>Vault Config Info</Text>,
                        },
                        {
                          title: <Text strong>Vault Currencies</Text>,
                        },
                        {
                          title: <Text strong>Preview</Text>,
                        },
                      ]}
                    />
                  </Card>
                  {/* Form Section */}
                  <Card style={styles.cardStepDisplay}>
                    <div>{forms[current]}</div>
                    {/* </Form> */}
                  </Card>
                </Row>
              </Col>
            </Row>

            {/* Submitt section */}
            <Card
              style={{
                marginBottom: 25,
                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                borderRadius: 20,
                padding: 5,
              }}
            >
              <Flex
                justify="space-between"
                style={{ paddingLeft: "20px", paddingRight: "40px" }}
              >
                {current === 0 && (
                  <Button
                    style={{
                      width: "12%",
                      height: "15%",
                      backgroundColor: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                      color: "black",
                    }}
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                )}
                {current > 0 && (
                  <Button
                    style={{
                      width: "10%",
                      height: "15%",
                      backgroundColor: "#15CCAE",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={prevButtonClick}
                  >
                    {labelConfig.previous}
                  </Button>
                )}
                {!isLastStep && (
                  <Button
                    style={{
                      width: "10%",
                      height: "15%",
                      backgroundColor: "#15CCAE",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={nextButtonClick}
                  >
                    {labelConfig.next}
                  </Button>
                )}
                {BOM.HasPermission("CREATE_SAVINGSPRODUCT") && isLastStep && (
                  <CustomButton
                    content="Submit"
                    style={{
                      width: "10%",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    onClick={onSubmit}
                    backgroundColor="#fff"
                    colorText="black"
                    hoverBackground="#F5F5F5"
                  />
                )}
              </Flex>
            </Card>
          </div>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddSYA0500);
